'use client'

import * as React from 'react'

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

type EnumSelectOption = {
  value: string
  label: string
  disabled?: boolean
}

type EnumSelectProps = Omit<React.ComponentProps<typeof Select>, 'children'> & {
  options: readonly EnumSelectOption[]
  placeholder?: string
  triggerProps?: React.ComponentProps<typeof SelectTrigger>
  contentProps?: React.ComponentProps<typeof SelectContent>
  'aria-label'?: string
}

function EnumSelect({
  options,
  placeholder = 'Select an option',
  triggerProps,
  contentProps,
  'aria-label': ariaLabel,
  ...props
}: EnumSelectProps) {
  const {
    className: triggerClassName,
    'aria-label': triggerAriaLabel,
    ...remainingTriggerProps
  } = triggerProps ?? {}

  return (
    <Select {...props}>
      <SelectTrigger
        aria-label={triggerAriaLabel ?? ariaLabel}
        className={cn('w-full', triggerClassName)}
        {...remainingTriggerProps}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent {...contentProps}>
        <SelectGroup>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export { EnumSelect, type EnumSelectOption, type EnumSelectProps }
